import { useEffect, useState } from 'react'
import { Typography, Card, Form, Row, Col } from 'antd'
import { FileTextOutlined, SendOutlined, ReloadOutlined } from '@ant-design/icons'
import Colors from '../utils/colors'
import { useDispatch, useSelector } from 'react-redux'
import { getAdminNotes, updateAdminNotes } from '../actions/constantsAction'
import { CustomButton } from '../components/ui/CustomButton'
import { CustomTextArea } from '../components/ui/CustomTextArea'
import { showToast } from '../utils/toast'

const { Title } = Typography

const Notes = () => {
  const dispatch = useDispatch()
  const { notes, loading, error, isUpdated } = useSelector((state) => state.adminNotes)
  const [currentNotes, setCurrentNotes] = useState('')
  const [originalNotes, setOriginalNotes] = useState('')
  const [form] = Form.useForm()

  useEffect(() => {
    dispatch(getAdminNotes())
  }, [dispatch])

  useEffect(() => {
    if (notes) {
      setCurrentNotes(notes)
      setOriginalNotes(notes)
      form.setFieldsValue({ notes })
    }
  }, [notes, form])

  useEffect(() => {
    if (isUpdated) {
      showToast('Notes updated successfully', 'success')
    }

    if (error) {
      showToast(error, 'error')
    }
  }, [isUpdated, error])

  const handleSubmit = () => {
    dispatch(updateAdminNotes(currentNotes))
  }

  const handleReset = () => {
    setCurrentNotes(originalNotes)
    form.setFieldsValue({ notes: originalNotes })
  }

  return (
    <div>
      <Title level={4} style={{ color: Colors.primary, marginBottom: 22, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <FileTextOutlined style={{ transform: 'scale(1.5)', marginRight: 12, color: Colors.primary }} />
        Admin Notes
      </Title>

      <Card style={{ borderRadius: '8px' }}>
        <Form form={form} layout="vertical">
          <Form.Item
            name="notes"
            label="Notes Template"
          >
            <CustomTextArea
              value={currentNotes}
              onChange={(e) => setCurrentNotes(e.target.value)}
              placeholder="Enter your admin notes..."
              rows={10}
              style={{ resize: 'vertical' }}
            />
          </Form.Item>
          
          <Row gutter={16}>
            <Col>
              <CustomButton
                classNames='create-btn'
                onClick={handleSubmit}
                loading={loading}
                style={{ 
                  height: '28px',
                  fontSize: '10px',
                  width: 'auto'
                }}
              >
                <SendOutlined /> Submit
              </CustomButton>
            </Col>
            <Col>
              <CustomButton
                onClick={handleReset}
                style={{ 
                  height: '28px',
                  fontSize: '10px',
                  width: 'auto'
                }}
              >
                <ReloadOutlined /> Reset
              </CustomButton>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  )
}

export default Notes